import React, {Component} from 'react';
import {connect} from 'react-redux';

import {
    Button,
    Row,
} from 'reactstrap';
import {Link} from 'react-router';

import BoolButtons from "../../../../components/controls/buttons/BoolButtons";
import GuarantorFrame from './GuarantorFrame';
import CreditForm from "../../../../components/credit/CreditForm";


class CreditFrameContainer extends Component {
    state = {
        has_guarantor: this.props.has_guarantor
    };

    toggleGuarantor = (val) => {
        val = val === 'true';
        this.setState({has_guarantor: !val});
    };

    render() {
        const {has_guarantor, tuVerified} = this.props;

        return (
            <div>
                {
                    tuVerified ? (
                        <div>
                            <Row>
                                <h3>You're all good to go!</h3>
                            </Row>
                            <hr/>
                            <p>You're all set to start applying to properties! Check back at the end of the 30 day period to re-verify your credit.</p>
                            <div className="center">
                                <Button color="primary" outline tag={Link} to="/dashboard/">Return to Dashboard</Button>
                            </div>
                        </div>
                    ) : (
                        <div>
                            <Row>
                                <h3>One last step...</h3>
                            </Row>
                            <hr/>
                            <p>Now for the fun part. Landlords need to know how risky it would be to have you rent from them. Questions like "Are they going to pay rent on time?" and "Have they robbed any banks?" could be floating around in their heads. To get them some peace of mind, we've partnered with TransUnion to give them credit and background checks. <b>This is what your PolyRents screening fee goes towards.</b></p>
                            <p>If you don’t have substantial (3+ years) of credit history, you'll probably need to use a guarantor. A guarantor guarantees to pay your rent if you fail to do so. The legal stuff surrounding guarantors is taken care of in your lease -- adding your guarantor to PolyRents is not legally binding.</p>
                            <p>Concerned that this check will affect your credit score? No worries necessary -- TransUnion performs a “soft pull” to get your credit, which will not negatively impact your credit score.</p>
                            <hr/>
                            <div className="center">
                                <BoolButtons falseText="I have a guarantor"
                                             trueText="I don't need a guarantor"
                                             width="15em"
                                             defaultValue={!has_guarantor}
                                             color="info"
                                             onChange={this.toggleGuarantor}/>
                            </div>
                            <hr/>
                            {
                                this.state.has_guarantor ? (
                                    <div>
                                        <h4><strong>Go ahead and give us your guarantor's info</strong></h4>
                                        <div className="text-info mb-2" style={{marginTop: '-1rem'}}>
                                            <small>Your guarantor will receive an email asking them to complete a credit check through PolyRents</small>
                                        </div>
                                        <GuarantorFrame/>
                                    </div>
                                ) : (
                                    <div>
                                        <h4><strong>We just need a little bit more info to get your credit report.</strong></h4>
                                        <CreditForm/>
                                    </div>
                                )
                            }
                        </div>
                    )
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        has_guarantor: !state.tenant.application.skip_guarantor,
        tuVerified: state.tenant.idmaStatus === 'Verified'
    };
};

export default connect(mapStateToProps)(CreditFrameContainer);



// WEBPACK FOOTER //
// ./src/containers/tenant/application/frames/CreditFrameContainer.js